import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import QRCode from 'react-qr-code'; // npm install react-qr-code

const mediaSources = {
  default: 'https://images.unsplash.com/photo-1742943679521-f4736500a471?q=80&w=3870&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  jungle: 'https://plus.unsplash.com/premium_photo-1673288456151-4f7b871863c9?q=80&w=3870&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  leaves: 'https://images.unsplash.com/photo-1604213410393-89f141bb96b8?q=80&w=3870&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  coastal: 'https://videos.pexels.com/video-files/1550080/1550080-uhd_2560_1440_30fps.mp4',
  mountain: 'https://videos.pexels.com/video-files/3177845/3177845-uhd_2560_1440_24fps.mp4',
  cityview: 'https://videos.pexels.com/video-files/3121459/3121459-uhd_2560_1440_24fps.mp4',
  rickroll: 'https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1&mute=1&loop=1&controls=0&rel=0&playsinline=1',
};

const overlayLogos = {
  default: '/qrylogo.png',
};

const defaultGifOverlay =
  'https://wipplecdn.b-cdn.net/wp-content/uploads/2021/02/d2dda3f0-750b-428e-a81d-6bd9a881f324-2-1.gif';

const gifSources = {
  default: defaultGifOverlay,
  cat: 'https://media.giphy.com/media/vFKqnCdLPNOKc/giphy.gif',
  upset: 'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExdHVmdHl1OTF6NnYzaTYzMW4yNGYyNXd4enB4Y2h1dGx0bXZqMzNtayZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/12XMGIWtrHBl5e/giphy.gif',
  excited: 'https://media1.giphy.com/media/Zaej3GIZTzCI8/200.webp',
  confetti: 'https://i.giphy.com/s2qXK8wAvkHTO.webp',
  moreuknow: 'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExOHRwNnJjNHk4aWthaDl1MDEzaWtyMmdkOHJkcDQ4eHB5anlsdWx2NCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3og0IMJcSI8p6hYQXS/giphy.gif',
  panic: 'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExamZpMmxveDh6MGI5YnlzcDAzcjJlbjdocTV0aHZkY3lrOTB5a3J0NiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/l3vQZ8ko4l0nvjm2Q/giphy.gif',
};

/* 
  NEW recognized params for date/time customizations
  - staticDateTime: User-supplied date/time for a static display
  - onlyDate, onlyTime, showCountdown: booleans
  - countdownDateTime: target date/time for countdown
*/
const recognizedParams = [
  {
    key: 'title',
    label: 'Title',
    exampleValue: 'Hello%20World',
    description: 'Sets the big title text on the screen.',
    usageExample: '?title=Hello%20World',
  },
  {
    key: 'subtext',
    label: 'Subtext',
    exampleValue: 'Enjoy%20Your%20Day',
    description: 'Sets the smaller text under the title.',
    usageExample: '?subtext=Enjoy%20Your%20Day',
  },
  {
    key: 'site',
    label: 'Site (Background)',
    exampleValue: 'site3',
    description: 'Chooses a preset background (image or video).',
    usageExample: '?site=site3',
  },
  {
    key: 'customMedia',
    label: 'Custom Media',
    exampleValue: 'https://example.com/myvideo.mp4',
    description: 'Lets you pick your own background image or video.',
    usageExample: '?customMedia=https://example.com/myvideo.mp4',
  },
  {
    key: 'customLogo',
    label: 'Custom Logo',
    exampleValue: 'https://example.com/mylogo.png',
    description: 'Lets you pick a custom logo image.',
    usageExample: '?customLogo=https://example.com/mylogo.png',
  },
  {
    key: 'hideLogos',
    label: 'Hide Logos',
    noValue: true,
    exampleValue: '(no value needed)',
    description: 'Hides both logos on the screen.',
    usageExample: '?title=Hello&hideLogos',
  },
  {
    key: 'disableGif',
    label: 'Disable GIF',
    noValue: true,
    exampleValue: '(no value needed)',
    description: 'Stops the GIF overlay from showing at all.',
    usageExample: '?customMedia=https://example.com/bg.jpg&disableGif',
  },
  {
    key: 'customGif',
    label: 'Custom GIF',
    exampleValue: 'https://example.com/myCoolGif.gif',
    description: 'Uses a different GIF or image for the overlay.',
    usageExample: '?customGif=https://example.com/myCoolGif.gif',
  },
  {
    key: 'titleColor',
    label: 'Title Color',
    exampleValue: 'FF0000',
    description: 'Sets the title color by HEX (no # needed).',
    usageExample: '?title=Hello&titleColor=FF0000',
  },
  {
    key: 'subtextColor',
    label: 'Subtext Color',
    exampleValue: '00FF00',
    description: 'Sets the subtext color by HEX (no # needed).',
    usageExample: '?subtext=Green%20Text&subtextColor=00FF00',
  },
  {
    key: 'hideDateTime',
    label: 'Hide Date/Time',
    noValue: true,
    exampleValue: '(no value needed)',
    description: 'Hides the Date & Time from the signage preview and final display.',
    usageExample: '?hideDateTime',
  },
  // === NEW PARAMETERS ===
  {
    key: 'staticDateTime',
    label: 'Static Date/Time',
    exampleValue: '2025-04-15T14:30',
    description: 'Displays a fixed date/time (overrides local).',
    usageExample: '?staticDateTime=2025-04-15T14:30',
  },
  {
    key: 'onlyDate',
    label: 'Only Date',
    noValue: true,
    exampleValue: '(no value needed)',
    description: 'Displays only the date portion of time.',
    usageExample: '?onlyDate',
  },
  {
    key: 'onlyTime',
    label: 'Only Time',
    noValue: true,
    exampleValue: '(no value needed)',
    description: 'Displays only the time portion of date/time.',
    usageExample: '?onlyTime',
  },
  {
    key: 'showCountdown',
    label: 'Countdown Mode',
    noValue: true,
    exampleValue: '(no value needed)',
    description: 'Shows a countdown to a specified date/time.',
    usageExample: '?showCountdown&countdownDateTime=2025-05-01T12:00',
  },
  {
    key: 'countdownDateTime',
    label: 'Countdown Target',
    exampleValue: '2025-05-01T12:00',
    description: 'The target date/time used when countdown mode is on.',
    usageExample: '?showCountdown&countdownDateTime=2025-05-01T12:00',
  },
];

const isVideoUrl = (url) => {
  return (
    /\.(mp4|webm|ogg)$/i.test(url) ||
    /youtube\.com|youtu\.be|vimeo\.com/.test(url)
  );
};

// Wrapper function to lock fields when user is not logged in
const LockedFieldWrapper = ({ isLoggedIn, children }) => {
    return React.cloneElement(children, {
      disabled: !isLoggedIn,
      style: { opacity: isLoggedIn ? 1 : 0.6, pointerEvents: isLoggedIn ? 'auto' : 'none' },
      title: isLoggedIn ? '' : 'Login required to modify this option',
    });
  };

function FullscreenDynamic({ isLoggedIn }) {
  const params = new URLSearchParams(window.location.search);
  const hasParams = params.toString().length > 0;

  // Build initial form state from recognized params
  const initialFormData = {};
  recognizedParams.forEach((rp) => {
    if (rp.noValue) {
      initialFormData[rp.key] = false;
    } else {
      initialFormData[rp.key] = '';
    }
  });

  const [formData, setFormData] = useState(initialFormData);
  const [isDirty, setIsDirty] = useState(false);

  // For previews
  const [previewSite, setPreviewSite] = useState('');
  const [previewCustomMedia, setPreviewCustomMedia] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [previewSubtext, setPreviewSubtext] = useState('');
  const [previewTitleColor, setPreviewTitleColor] = useState('#fff');
  const [previewSubtextColor, setPreviewSubtextColor] = useState('#fff');
  const [previewHideLogos, setPreviewHideLogos] = useState(false);
  const [previewCustomGif, setPreviewCustomGif] = useState('');
  const [previewHideDateTime, setPreviewHideDateTime] = useState(false);

  // NEW date/time state
  const [localTime, setLocalTime] = useState('');
  const [countdownString, setCountdownString] = useState('Initializing countdown...');

  // For overlay toggling
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentMedia, setCurrentMedia] = useState('media');
  const videoRef = useRef(null);
  const waitTime = 11000;

  // ============= Date/Time Logic =============
  // Keep a live local time
  useEffect(() => {
    const updateTime = () => setLocalTime(new Date().toLocaleString());
    updateTime();
    const intervalId = setInterval(updateTime, 1000);
    return () => clearInterval(intervalId);
  }, []);

  // If "showCountdown" is used, we track a separate countdown
  const [countdownTarget, setCountdownTarget] = useState('');
  useEffect(() => {
    let countdownInterval;
    if (params.has('showCountdown') && countdownTarget) {
      countdownInterval = setInterval(() => {
        const now = new Date();
        const target = new Date(countdownTarget);
        const diff = target - now;
        if (diff <= 0) {
          // Countdown ended
          setCountdownString('Countdown Complete');
          clearInterval(countdownInterval); // prevent redundant setState calls
        } else {
          // Calculate days/hours/min/sec
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
          const hours = Math.floor(
            (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
          );
          const minutes = Math.floor(
            (diff % (1000 * 60 * 60)) / (1000 * 60),
          );
          const seconds = Math.floor((diff % (1000 * 60)) / 1000);
          setCountdownString(
            `${days}d ${hours}h ${minutes}m ${seconds}s`,
          );
        }
      }, 1000);
    }
    return () => {
      if (countdownInterval) clearInterval(countdownInterval);
    };
  }, [countdownTarget, params]);

  // ============= URL Construction =============
  const buildUrlWithQueries = (data) => {
    const queryParts = [];
  
    recognizedParams.forEach((rp) => {
      if (rp.noValue && data[rp.key]) {
        queryParts.push(rp.key);
      } else if (data[rp.key]) {
        queryParts.push(`${rp.key}=${encodeURIComponent(data[rp.key])}`);
      }
    });
  
    return `${window.location.origin}${window.location.pathname}?${queryParts.join('&')}`;
  };

  const [constructedUrl, setConstructedUrl] = useState('');
  useEffect(() => {
    setConstructedUrl(buildUrlWithQueries(formData));
  }, [formData]);

  // ============= Recognized vs Unrecognized =============
  const recognizedWithStatus = [];
  const unrecognizedParams = [];
  recognizedParams.forEach((rp) => {
    if (params.has(rp.key)) {
      const value = params.get(rp.key);
      if (rp.noValue) {
        recognizedWithStatus.push({ ...rp, status: 'PASS' });
      } else if (value) {
        recognizedWithStatus.push({ ...rp, status: 'PASS' });
      } else {
        recognizedWithStatus.push({ ...rp, status: 'MISSING' });
      }
    } else {
      recognizedWithStatus.push({ ...rp, status: 'MISSING' });
    }
  });
  for (const [key] of params.entries()) {
    const found = recognizedParams.some((rp) => rp.key === key);
    if (!found) {
      unrecognizedParams.push(key);
    }
  }
  const getBackgroundColor = (status) => {
    if (status === 'PASS') return 'limegreen';
    if (status === 'MISSING') return 'red';
    if (status === 'UNUSED') return 'grey';
    return 'white';
  };

  // ============= Final Signage Extraction =============
  const title = params.get('title') || 'Default Title';
  const subtext = params.get('subtext') || 'Default Subtext';
  const siteKey = params.get('site') || 'default';
  const hideLogos = params.has('hideLogos');
  const disableGif = params.has('disableGif');
  const customMedia = params.get('customMedia') || '';
  const customLogo = params.get('customLogo') || '';
  const customGif = params.get('customGif') || '';
  const titleColorParam = params.get('titleColor');
  const finalTitleColor = titleColorParam ? `#${titleColorParam}` : '#fff';
  const subtextColorParam = params.get('subtextColor');
  const finalSubtextColor = subtextColorParam ? `#${subtextColorParam}` : '#fff';
  const hideDateTime = params.has('hideDateTime');

  // NEW date/time param flags
  const staticDateTime = params.get('staticDateTime') || '';
  const onlyDate = params.has('onlyDate');
  const onlyTime = params.has('onlyTime');
  const showCountdown = params.has('showCountdown');
  const countdownDateTime = params.get('countdownDateTime') || '';
  useEffect(() => {
    let countdownInterval;
  
    if (showCountdown && countdownDateTime) {
      countdownInterval = setInterval(() => {
        const now = new Date().getTime();
        const target = new Date(countdownDateTime).getTime();
        const difference = target - now;
  
        if (difference <= 0) {
          setCountdownString('Countdown Complete');
          clearInterval(countdownInterval);
        } else {
          const days = Math.floor(difference / (1000 * 60 * 60 * 24));
          const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((difference % (1000 * 60)) / 1000);
  
          setCountdownString(`${days}d ${hours}h ${minutes}m ${seconds}s`);
        }
      }, 1000);
    }
  
    return () => clearInterval(countdownInterval);
  }, [showCountdown, countdownDateTime]);
  
  useEffect(() => {
    let countdownInterval;
    if (params.has('showCountdown') && countdownTarget) {
      countdownInterval = setInterval(() => {
        // ...
      }, 1000);
    }
    return () => countdownInterval && clearInterval(countdownInterval);
  }, [countdownTarget, params]);

  // Decide which background
  const chosenMediaUrl =
    customMedia || mediaSources[siteKey] || mediaSources.default;
  const isVideo = isVideoUrl(chosenMediaUrl);
  const overlayLogoUrl = customLogo || overlayLogos.default;
  const gifOverlayUrl = customGif || defaultGifOverlay;

  // Only cycle background overlays if we have params
  useEffect(() => {
    let isMounted = true;
    const cyclePlayback = () => {
      if (!isMounted) return;
      setCurrentMedia('media');
      let duration = waitTime;

      if (isVideo && videoRef.current && videoRef.current.duration) {
        duration = (videoRef.current.duration || 10) * 1000;
      }
      if (!disableGif) {
        setTimeout(() => {
          if (!isMounted) return;
          setCurrentMedia('gif');
          setTimeout(() => {
            if (!isMounted) return;
            cyclePlayback();
          }, waitTime);
        }, duration);
      }
    };
    if (hasParams) {
      cyclePlayback();
    }
    return () => {
      isMounted = false;
    };
  }, [chosenMediaUrl, isVideo, disableGif, hasParams]);

  // Hide the navbar only if we have params
  useEffect(() => {
    if (hasParams) {
      const navbar = document.querySelector('.navbar');
      if (navbar) navbar.style.display = 'none';
      document.body.style.margin = '0';
      document.body.style.padding = '0';
      return () => {
        if (navbar) navbar.style.display = '';
        document.body.style.margin = '';
        document.body.style.padding = '';
      };
    }
  }, [hasParams]);

  // ============= Form Updates =============
  const handleChange = (key, value) => {
    setFormData((prev) => {
      const newData = { ...prev, [key]: value };
      if (!isDirty) {
        const somethingChanged = Object.keys(newData).some(
          (k) => newData[k] !== initialFormData[k],
        );
        setIsDirty(somethingChanged);
      } else {
        setIsDirty(true);
      }
      return newData;
    });
  };

  // Update the preview states
  useEffect(() => {
    setPreviewTitle(formData.title || '');
    setPreviewSubtext(formData.subtext || '');
    const tColor = formData.titleColor
      ? `#${formData.titleColor.replace(/^#/, '')}`
      : '#fff';
    setPreviewTitleColor(tColor);

    const sColor = formData.subtextColor
      ? `#${formData.subtextColor.replace(/^#/, '')}`
      : '#fff';
    setPreviewSubtextColor(sColor);

    setPreviewSite(formData.site);
    setPreviewCustomMedia(formData.customMedia);
    setPreviewHideLogos(formData.hideLogos);
    setPreviewCustomGif(formData.customGif);
    setPreviewHideDateTime(formData.hideDateTime);
  }, [formData]);

  // If the user sets showCountdown in the form, we track the countdown date
  useEffect(() => {
    if (formData.showCountdown && formData.countdownDateTime) {
      setCountdownTarget(formData.countdownDateTime);
    } else {
      setCountdownTarget('');
    }
  }, [formData.showCountdown, formData.countdownDateTime]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newSearch = constructedUrl.split('?')[1] || '';
    if (newSearch) {
      window.location.search = `?${newSearch}`;
    } else {
      window.location.search = '';
    }
  };

  // Decide how to present date/time for final signage:
  // 1) If hideDateTime => no date/time shown.
  // 2) If showCountdown => show countdownString if available
  // 3) If staticDateTime => use that value
  // 4) Else use localTime
  // Then filter with onlyDate / onlyTime
  let finalDateTimeDisplay = '';

if (!hideDateTime) {
  if (showCountdown && countdownDateTime) {
    finalDateTimeDisplay = countdownString;
  } else {
    const baseTime = staticDateTime ? new Date(staticDateTime) : new Date(localTime);

    if (onlyDate) {
      finalDateTimeDisplay = baseTime.toLocaleDateString();
    } else if (onlyTime) {
      finalDateTimeDisplay = baseTime.toLocaleTimeString();
    } else {
      finalDateTimeDisplay = baseTime.toLocaleString();
    }
  }
}

  // ============= Lightbox toggles =============
  const handleOpenLightbox = () => setLightboxOpen(true);
  const handleCloseLightbox = () => setLightboxOpen(false);

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(constructedUrl);
  };

  const finalUrl = typeof window !== 'undefined' ? window.location.href : '';

  // ============= Helper to manage disabling logic in the form =============
  const disableOtherDateOptions = (key) => {
    // If the user has checked "hideDateTime", "onlyDate", "onlyTime",
    // "showCountdown", or a "staticDateTime" was set, we selectively disable the conflicting ones
    // We'll do it in the UI. 
    // We'll return a boolean that says whether to disable a certain field, based on "key"
  };

  // ============= Render =============
  return (
    <>
      {/* If no URL params, show the form + a "live preview" */}
      {!hasParams && (
        <div
          style={{
            minHeight: '100vh',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Background Preview */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 0,
              overflow: 'hidden',
            }}
          >
            {previewCustomMedia && isVideoUrl(previewCustomMedia) ? (
              <video
                src={previewCustomMedia}
                autoPlay
                muted
                loop
                playsInline
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  background: `url(${previewCustomMedia ||
                    mediaSources[previewSite] ||
                    mediaSources.default}) center center / cover no-repeat`,
                }}
              />
            )}
          </div>

          {/* Title at top */}
          <div
            style={{
              position: 'relative',
              zIndex: 1,
              padding: '2rem',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            {!previewHideLogos && (
              <img
                src={formData.customLogo || overlayLogos.default}
                alt="Overlay Logo"
                style={{ maxWidth: '220px', filter: 'drop-shadow(0 0 10px #FFF)' }}
              />
            )}
            <h1
              style={{
                color: previewTitleColor,
                textShadow: '0 0 6px #000',
                fontFamily: 'Parnaso Medium Condensed, sans-serif',
              }}
            >
              {previewTitle || 'Preview Title'}
            </h1>
          </div>

          {/* Subtext & date/time at bottom */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'center',
              position: 'relative',
              zIndex: 1,
              padding: '2rem',
              textAlign: 'center',
            }}
          >
            <div>
              <h2
                style={{
                  color: previewSubtextColor,
                  textShadow: '0 0 6px #000',
                }}
              >
                {previewSubtext || 'Preview Subtext'}
              </h2>
              {/* Just show localTime unless "hideDateTime" is checked in form */}
              {!previewHideDateTime && (
                <h3 style={{ color: '#ccc', textShadow: '0 0 4px #000', marginTop: '1rem' }}>
                  {localTime}
                </h3>
              )}
            </div>
          </div>

          {/* Form for new settings */}
          <Container
            className="pt-3 pb-3 mb-5"
            style={{
              position: 'relative',
              zIndex: 2,
              backgroundColor: 'rgba(255,255,255,0.85)',
              borderRadius: '8px',
              maxWidth: '1000px',
              marginTop: 'auto',
              alignSelf: 'center',
            }}
          >
            <Form onSubmit={handleSubmit}>
              {/* Title/Subtext */}
              <Row className="mb-2">
                <Col lg={4} xs={8}>
                  <Form.Group>
                    <Form.Label>Choose a Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.title}
                      onChange={(e) => handleChange('title', e.target.value)}
                      placeholder="Complimentary Pretzel Day"
                    />
                  </Form.Group>
                </Col>
                <Col lg={2} xs={4}>
                  <Form.Group>
                    <Form.Label>Title Color</Form.Label>
                    <Form.Control
                      className="px-0 py-0"
                      type="color"
                      value={`#${formData.titleColor.replace(/^#/, '')}`}
                      onChange={(e) =>
                        handleChange('titleColor', e.target.value.replace(/^#/, ''))
                      }
                    />
                  </Form.Group>
                </Col>
                <Col lg={4} xs={8}>
                  <Form.Group>
                    <Form.Label>Add Subtext</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.subtext}
                      onChange={(e) => handleChange('subtext', e.target.value)}
                      placeholder="Lobby - Now until 4 O'Clock"
                    />
                  </Form.Group>
                </Col>
                <Col lg={2} xs={4}>
                  <Form.Group>
                    <Form.Label>Subtext Color</Form.Label>
                    <Form.Control
                      className="px-0 py-0"
                      type="color"
                      value={`#${formData.subtextColor.replace(/^#/, '')}`}
                      onChange={(e) =>
                        handleChange('subtextColor', e.target.value.replace(/^#/, ''))
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Logo/GIF/Hide */}
              <Row className="mb-2">
                <Col lg={8} xs={12}>
                  <Form.Group>
                    {/* <Form.Label>Custom Logo URL</Form.Label> */}
                    <Form.Control
                      type="text"
                      value={formData.customLogo}
                      onChange={(e) => handleChange('customLogo', e.target.value)}
                      placeholder="https://example.com/mylogo.png"
                    />
                  </Form.Group>
                </Col>

                <Col lg={2} xs={6}>
                  <Form.Group>
                    <LockedFieldWrapper isLoggedIn={isLoggedIn}>
                      <Form.Check
                        type="checkbox"
                        checked={formData.hideLogos}
                        onChange={(e) => handleChange('hideLogos', e.target.checked)}
                        label="Hide Logo"
                        className="pt-1"
                        alt-text="Premium"
                      />
                    </LockedFieldWrapper>
                  </Form.Group>
                </Col>
                
                <Col lg={2} xs={6}>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      checked={formData.disableGif}
                      onChange={(e) => handleChange('disableGif', e.target.checked)}
                      label="Hide Overlay"
                      className="pt-1"
                    />
                  </Form.Group>
                </Col>
                
                
              </Row>

              {/* Background */}
              <Row className="mb-2">
                <Col lg={8} xs={12}>
                  <Form.Group>
                    <Form.Label>Background (Image, Video, GIF)</Form.Label>
                    <div className="d-flex flex-wrap">
                      {Object.keys(mediaSources).map((key) => {
                        const url = mediaSources[key];
                        const isVid = isVideoUrl(url);
                        let previewElement;
                        if (isVid) {
                          if (url.includes('youtube.com') || url.includes('youtu.be')) {
                            previewElement = (
                              <iframe
                                title={key}
                                src={url}
                                style={{ width: '80px', height: '55px', border: 'none' }}
                                allow="autoplay; muted;"
                              />
                            );
                          } else {
                            previewElement = (
                              <video
                                src={url}
                                muted
                                autoPlay
                                loop
                                playsInline
                                style={{
                                  width: '80px',
                                  height: '55px',
                                  objectFit: 'cover',
                                }}
                              />
                            );
                          }
                        } else {
                          previewElement = (
                            <div
                              style={{
                                width: '80px',
                                height: '55px',
                                background: `url(${url}) center center / cover no-repeat`,
                              }}
                            />
                          );
                        }

                        return (
                          <div
                            key={key}
                            onClick={() => {
                              handleChange('site', key);
                              handleChange('customMedia', mediaSources[key]);
                            }}
                            style={{
                              width: '80px',
                              margin: '5px',
                              textAlign: 'center',
                              cursor: 'pointer',
                              border:
                                formData.site === key
                                  ? '3px solid #007bff'
                                  : '1px solid #ccc',
                            }}
                          >
                            {previewElement}
                            <div style={{ fontSize: '0.75rem', marginTop: '2px' }}>{key}</div>
                          </div>
                        );
                      })}
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={4} xs={12}>
                  <Form.Group>
                    <Form.Label>Custom Background URL</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.customMedia}
                      onChange={(e) => handleChange('customMedia', e.target.value)}
                      placeholder="https://example.com/bg.jpg"
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Overlay */}
              <Row className="mb-2">
                <Col lg={8} xs={12}>
                  <Form.Group>
                    <Form.Label>Overlay (Image, Video, GIF)</Form.Label>
                    <div className="d-flex flex-wrap">
                      {Object.keys(gifSources).map((key) => {
                        const gifUrl = gifSources[key];
                        return (
                          <div
                            key={key}
                            onClick={() => handleChange('customGif', gifUrl)}
                            style={{
                              width: '80px',
                              margin: '5px',
                              textAlign: 'center',
                              cursor: 'pointer',
                              border:
                                formData.customGif === gifUrl
                                  ? '3px solid #007bff'
                                  : '1px solid #ccc',
                            }}
                          >
                            <img
                              src={gifUrl}
                              alt={key}
                              style={{
                                width: '80px',
                                height: '55px',
                                objectFit: 'cover',
                              }}
                            />
                            <div style={{ fontSize: '0.75rem', marginTop: '2px' }}>{key}</div>
                          </div>
                        );
                      })}
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={4} xs={12}>
                  <Form.Group>
                    <Form.Label>Custom Overlay URL</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.customGif}
                      onChange={(e) => handleChange('customGif', e.target.value)}
                      placeholder="https://example.com/myCoolGif.gif"
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* NEW date/time control row */}
              <Row className="mb-2">
                {/* Static Date/Time */}
                <Col lg={3} xs={6}>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      checked={Boolean(formData.staticDateTime)}
                      // If user unchecks it, we clear the param
                      onChange={(e) => handleChange('staticDateTime', e.target.checked ? new Date().toISOString().slice(0,16) : '')}
                      label="Static Date/Time"
                      disabled={
                        formData.hideDateTime ||
                        formData.onlyDate ||
                        formData.onlyTime ||
                        formData.showCountdown
                      }
                    />
                    {formData.staticDateTime && (
                      <Form.Control
                        type="datetime-local"
                        value={formData.staticDateTime}
                        onChange={(e) => handleChange('staticDateTime', e.target.value)}
                        className="mt-2"
                      />
                    )}
                  </Form.Group>
                </Col>

                {/* Countdown */}
                <Col lg={3} xs={6} className="Xd-none">
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      checked={formData.showCountdown}
                      onChange={(e) => handleChange('showCountdown', e.target.checked)}
                      label="Show Countdown"
                      disabled={
                        formData.hideDateTime ||
                        formData.onlyDate ||
                        formData.onlyTime ||
                        Boolean(formData.staticDateTime)
                      }
                    />
                    {formData.showCountdown && (
                      <Form.Control
                        type="datetime-local"
                        value={formData.countdownDateTime}
                        onChange={(e) => handleChange('countdownDateTime', e.target.value)}
                        className="mt-2"
                      />
                    )}
                  </Form.Group>
                </Col>

                <Col lg={2} xs={4}>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      checked={formData.hideDateTime}
                      onChange={(e) => handleChange('hideDateTime', e.target.checked)}
                      label="Hide Date/Time"
                      className=""
                      disabled={
                        formData.onlyDate ||
                        formData.onlyTime ||
                        formData.showCountdown ||
                        Boolean(formData.staticDateTime)
                      }
                    />
                  </Form.Group>
                </Col>

                {/* Only Date */}
                <Col lg={2} xs={4}>
                  <Form.Group className="">
                    <Form.Check
                      type="checkbox"
                      checked={formData.onlyDate}
                      onChange={(e) => handleChange('onlyDate', e.target.checked)}
                      label="Hide Only Time"
                      disabled={
                        formData.hideDateTime ||
                        formData.showCountdown ||
                        Boolean(formData.staticDateTime) ||
                        formData.onlyTime
                      }
                    />
                  </Form.Group>
                </Col>

                {/* Only Time */}
                <Col lg={2} xs={4}>
                  <Form.Group className="">
                    <Form.Check
                      type="checkbox"
                      checked={formData.onlyTime}
                      onChange={(e) => handleChange('onlyTime', e.target.checked)}
                      label="Hide Only Date"
                      disabled={
                        formData.hideDateTime ||
                        formData.showCountdown ||
                        Boolean(formData.staticDateTime) ||
                        formData.onlyDate
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
              

              {/* Copy/Load */}
              <Row className="mb-2">
                <Col lg={8} xs={8}>
                  <Form.Group>
                    <div style={{ display: 'flex', gap: '5px' }}>
                      <Form.Control
                        type="text"
                        value={constructedUrl}
                        readOnly
                        onClick={handleCopyUrl}
                        style={{ cursor: 'pointer' }}
                        title="Click to copy"
                        className="mt-2"
                      />
                      <Button onClick={handleCopyUrl} variant="success" className="mt-2">
                        Copy
                      </Button>
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={4} xs={4} className="text-right">
                  <Button
                    variant="success"
                    type="submit"
                    disabled={!isDirty}
                    className="mt-2"
                  >
                    Apply Settings & Load Display
                  </Button>
                </Col>
              </Row>
            </Form>
          </Container>
        </div>
      )}

      {/* If we have URL params, final signage display */}
      {hasParams && (
        <Container
          fluid
          style={{
            height: '100vh',
            position: 'relative',
            overflow: 'hidden',
            padding: 0,
            margin: 0,
            fontFamily: 'Parnaso Medium Condensed, sans-serif',
            fontWeight: 500,
            color: '#000',
          }}
        >
          {/* Background */}
          <div
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              zIndex: 0,
            }}
          >
            {currentMedia === 'gif' ? (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  background: `url(${gifOverlayUrl}) center center / contain no-repeat`,
                }}
              />
            ) : isVideo ? (
              chosenMediaUrl.endsWith('.mp4') ? (
                <video
                  ref={videoRef}
                  src={chosenMediaUrl}
                  autoPlay
                  muted
                  loop
                  playsInline
                  onLoadedMetadata={() => {
                    if (videoRef.current) videoRef.current.play();
                  }}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <iframe
                  ref={videoRef}
                  title="video"
                  src={chosenMediaUrl}
                  frameBorder="0"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                  style={{
                    width: '100%',
                    height: '100%',
                    border: 0,
                  }}
                />
              )
            ) : (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  background: `url(${chosenMediaUrl}) center center / cover no-repeat`,
                }}
              />
            )}
          </div>

          {/* Foreground content (title, subtext, date/time) */}
          {currentMedia !== 'gif' && (
            <div
              style={{
                position: 'relative',
                zIndex: 1,
                height: '100%',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  padding: '2rem',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '1rem',
                }}
              >
                {!hideLogos && (
                  <a href="/"><img
                    src={overlayLogoUrl}
                    alt="Overlay Logo"
                    style={{ maxWidth: '220px', filter: 'drop-shadow(0 0 10px #FFF)' }}
                  /></a>
                )}
                <h1
                  style={{
                    color: finalTitleColor,
                    textShadow: '0 0 6px #000',
                    fontFamily: 'Parnaso Medium Condensed, sans-serif',
                  }}
                >
                  {title}
                </h1>
              </div>
              <div style={{ padding: '2rem', textAlign: 'center' }}>
                <h2
                  style={{
                    color: finalSubtextColor,
                    textShadow: '0 0 6px #000',
                  }}
                >
                  {subtext}
                </h2>
                {/* Conditionally render finalDateTimeDisplay */}
                {finalDateTimeDisplay && (
                  <h3
                    style={{
                      color: '#ccc',
                      textShadow: '0 0 4px #000',
                      marginTop: '1rem',
                    }}
                  >
                    {finalDateTimeDisplay}
                  </h3>
                )}
              </div>
            </div>
          )}

          {/* QR code + Lightbox */}
          <div
            onClick={handleOpenLightbox}
            style={{
              position: 'fixed',
              bottom: '20px',
              right: '20px',
              cursor: 'pointer',
              zIndex: 9999,
              background: '#fff',
              padding: '4px',
              borderRadius: '8px',
              boxShadow: '0 0 4px rgba(0,0,0,0.4)',
            }}
          >
            <QRCode value={finalUrl} size={70} />
          </div>

          {lightboxOpen && (
            <div
              onClick={(e) => {
                if (e.target.id === 'lightbox-background') {
                  handleCloseLightbox();
                }
              }}
              id="lightbox-background"
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(0, 0, 0, 0.8)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  background: '#fff',
                  padding: '1rem',
                  borderRadius: '6px',
                  maxWidth: '90%',
                  minWidth: '70%',
                  maxHeight: '90%',
                  overflowY: 'auto',
                  position: 'relative',
                  fontFamily: 'Verdana, sans-serif',
                }}
              >
                <div
                  onClick={handleCloseLightbox}
                  style={{
                    position: 'absolute',
                    top: '8px',
                    right: '12px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                  }}
                >
                  X
                </div>

                <h5 style={{ marginBottom: '1rem' }}>How to Use These URL Queries</h5>
                <p style={{ fontSize: '12px' }}>
                  This table shows each recognized URL parameter, whether it passed or is missing,
                  and what it does. To add more than one parameter, connect them with <strong>&</strong>.
                </p>

                <table
                  style={{
                    borderCollapse: 'collapse',
                    width: '100%',
                    marginTop: '1rem',
                    fontSize: '12px',
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: '#f2f2f2' }}>
                      <th
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          textAlign: 'left',
                          width: '10%',
                        }}
                      >
                        Status
                      </th>
                      <th
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          textAlign: 'left',
                          width: '10%',
                        }}
                      >
                        Parameter
                      </th>
                      <th
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          textAlign: 'left',
                          width: '20%',
                        }}
                      >
                        Example Value
                      </th>
                      <th
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          textAlign: 'left',
                          width: '30%',
                        }}
                      >
                        What It Does
                      </th>
                      <th
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          textAlign: 'left',
                          width: '30%',
                        }}
                      >
                        Usage Example
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {recognizedWithStatus.map((p) => (
                      <tr key={p.key}>
                        <td
                          style={{
                            border: '1px solid #ccc',
                            padding: '8px',
                            backgroundColor: getBackgroundColor(p.status),
                            color: '#fff',
                            fontWeight: 'bold',
                          }}
                        >
                          {p.status}
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                          {p.label}
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                          {p.exampleValue}
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                          {p.description}
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                          {p.usageExample}
                        </td>
                      </tr>
                    ))}
                    {unrecognizedParams.map((up) => (
                      <tr key={up}>
                        <td
                          style={{
                            border: '1px solid #ccc',
                            padding: '8px',
                            backgroundColor: getBackgroundColor('UNUSED'),
                            color: '#fff',
                            fontWeight: 'bold',
                          }}
                        >
                          UNUSED
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{up}</td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>N/A</td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                          This parameter is not recognized by the system.
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>N/A</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <h5 style={{ marginTop: '1rem' }}>How to Combine Queries</h5>
                <p style={{ fontSize: '12px' }}>
                  Start your link with a <code>?</code> before the first query. For each extra
                  query, use <code>&</code>.
                </p>
                <p style={{ fontSize: '12px', fontStyle: 'italic' }}>
                  Example:
                  <br />
                  https://www.example.com/FullscreenDynamic
                  <strong>
                    ?title=Hello
                    &amp;customMedia=https://example.com/video.mp4
                    &amp;hideLogos
                    &amp;showCountdown
                    &amp;countdownDateTime=2025-05-01T12:00
                  </strong>
                </p>
              </div>
            </div>
          )}
        </Container>
      )}
    </>
  );
}

export default FullscreenDynamic;
